import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToolbarModule } from 'primeng/toolbar';
import { TableModule } from 'primeng/table';
import { MenuModule } from 'primeng/menu';
import { AccordionModule } from 'primeng/accordion';
import { ToastModule } from 'primeng/toast';
import { SharedModule } from 'primeng/api';

import { TranslateModule } from '@ngx-translate/core';
import { PrimengSharedModule } from '@hvlng/framework-core/shared';

import { HvlFormItemModule, HvlFormMessageModule } from '@hvlng/framework-core/form';
import { UiPageHeaderModule, UiSharedModule } from 'ui-shared';
import { PositionPickerComponent } from './component/position-picker.component';
import { PositionPickerListComponent } from './component/position-picker-list.component';
import { PositionPickerSearchFormComponent } from './component/position-picker-search-form.component';

@NgModule({
    declarations: [PositionPickerComponent, PositionPickerListComponent, PositionPickerSearchFormComponent],
    exports: [PositionPickerComponent, PositionPickerListComponent, PositionPickerSearchFormComponent],
    imports: [
        CommonModule,
        CommonModule,
        PrimengSharedModule,
        ReactiveFormsModule,
        HvlFormItemModule,
        ToolbarModule,
        UiPageHeaderModule,
        TableModule,
        MenuModule,
        AccordionModule,
        UiSharedModule,
        TranslateModule,
        ToastModule,
        FormsModule,
        SharedModule,
        HvlFormMessageModule,
    ]
})
export class PositionPickerModule {}
